import { stringField } from 'common/utils/form/fieldTypes';

export default {
  name: stringField({ required: true }),
  label: stringField({ required: true }),
  symbol: stringField({ required: true })
};
